import ArrowRight from "assets/img/svg/arrowRight";
import StyledButton from "components/shared/StyledButton";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

export type ImportModalButtonVariant = "continue" | "validate" | "previous" | "confirm" | "retry" | "close" | "ghost";

type ImportModalButtonProps = {
    variant: ImportModalButtonVariant;
    onClick: () => void;
    disabled?: boolean;
    loading?: boolean;
    label?: string;
    endIcon?: ReactNode;
};

const VARIANT_I18N: Record<ImportModalButtonVariant, string> = {
    continue: "ImportData.Continue",
    validate: "ImportData.Validate",
    previous: "ImportData.PrevStep",
    confirm: "ImportData.Confirm",
    retry: "ImportData.Retry",
    close: "ImportData.Close",
    ghost: "ImportData.Close",
};

const ghostSx = {
    "&.MuiButton-root": {
        border: "none",
        textDecoration: "underline",
        borderRadius: "5px",
        backgroundColor: "transparent",
        "&:hover": {
            backgroundColor: "transparent",
            textDecoration: "underline",
        },
    },
};

const ImportModalButton = ({ variant, onClick, disabled, loading, label, endIcon }: ImportModalButtonProps) => {
    const [t] = useTranslation();
    const isGhost = variant === "previous" || variant === "ghost";
    const showArrow = variant === "continue" || variant === "validate";

    return (
        <StyledButton
            buttonType={isGhost ? "secondary" : "primary"}
            sx={isGhost ? ghostSx : undefined}
            onClick={onClick}
            disabled={disabled || loading}
            loading={loading}
        >
            {label ?? t(VARIANT_I18N[variant])}
            {showArrow && !loading ? <ArrowRight /> : null}
            {!showArrow && !loading ? endIcon : null}
        </StyledButton>
    );
};

export default ImportModalButton;
